var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isLoading
    ? _c(
        "v-container",
        { staticClass: "flex-column", attrs: { fluid: "" } },
        [
          _c("h1", { staticClass: "page-title page-title__primary" }, [
            _vm._v("Параметры адаптации"),
          ]),
          _c("p", [
            _vm._v(
              "Мы уже выбрали оптимальные параметры адаптации. Вы можете поменять их, при необходимости."
            ),
          ]),
          _vm.isFinished
            ? _c("v-alert", { attrs: { color: "success", dark: "" } }, [
                _vm._v("Расчет выполнен успешно"),
              ])
            : _vm._e(),
          _vm.hasError
            ? _c("v-alert", { attrs: { color: "red" } }, [
                _vm._v(_vm._s(_vm.taskError)),
              ])
            : _vm._e(),
          _c("v-select", {
            attrs: {
              items: _vm.models,
              label: "Симулятор",
              outlined: "",
              "hide-details": "",
            },
            model: {
              value: _vm.optimizeParams.model,
              callback: function ($$v) {
                _vm.$set(_vm.optimizeParams, "model", $$v)
              },
              expression: "optimizeParams.model",
            },
          }),
          _c(
            "v-radio-group",
            {
              model: {
                value: _vm.taskType,
                callback: function ($$v) {
                  _vm.taskType = $$v
                },
                expression: "taskType",
              },
            },
            _vm._l(_vm.analysisTypes, function (type) {
              return _c(
                "div",
                { key: type.id },
                [
                  _c("v-radio", {
                    attrs: {
                      value: type.code,
                      label: type.title,
                      disabled: type.disabled,
                    },
                  }),
                  _c("div", { staticClass: "v-radio__description" }, [
                    _vm._v(_vm._s(type.description)),
                  ]),
                ],
                1
              )
            }),
            0
          ),
          _c(
            "v-expansion-panels",
            [
              _c(
                "v-expansion-panel",
                { attrs: { disabled: _vm.isFinished } },
                [
                  _c("v-expansion-panel-header", [
                    _vm._v("Поменять параметры адаптации"),
                  ]),
                  _c(
                    "v-expansion-panel-content",
                    [
                      _c(
                        "v-form",
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Ковариация",
                              type: "number",
                              outlined: "",
                            },
                            model: {
                              value: _vm.optimizeParams.covariance,
                              callback: function ($$v) {
                                _vm.$set(_vm.optimizeParams, "covariance", $$v)
                              },
                              expression: "optimizeParams.covariance",
                            },
                          }),
                          _c("v-text-field", {
                            attrs: {
                              label: "Отклонение",
                              type: "number",
                              outlined: "",
                            },
                            model: {
                              value: _vm.optimizeParams.deviation,
                              callback: function ($$v) {
                                _vm.$set(_vm.optimizeParams, "deviation", $$v)
                              },
                              expression: "optimizeParams.deviation",
                            },
                          }),
                          _c("v-text-field", {
                            attrs: {
                              label: "Количество ансамблей",
                              type: "number",
                              outlined: "",
                            },
                            model: {
                              value: _vm.optimizeParams.n_ensemble,
                              callback: function ($$v) {
                                _vm.$set(_vm.optimizeParams, "n_ensemble", $$v)
                              },
                              expression: "optimizeParams.n_ensemble",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.needRelativePermCoeffs
                ? _c(
                    "v-expansion-panel",
                    { attrs: { disabled: _vm.isFinished } },
                    [
                      _c("v-expansion-panel-header", [
                        _vm._v(
                          "Поменять стартовые коэффициенты для подбора ОФП"
                        ),
                      ]),
                      _c(
                        "v-expansion-panel-content",
                        [
                          _c(
                            "v-form",
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "a",
                                  type: "number",
                                  outlined: "",
                                },
                                model: {
                                  value: _vm.optimizeParams.a,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.optimizeParams, "a", $$v)
                                  },
                                  expression: "optimizeParams.a",
                                },
                              }),
                              _c("v-text-field", {
                                attrs: {
                                  label: "no",
                                  type: "number",
                                  outlined: "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [
                                          _vm._v("n"),
                                          _c("sub", [_vm._v("o")]),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  481073933
                                ),
                                model: {
                                  value: _vm.optimizeParams.no,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.optimizeParams, "no", $$v)
                                  },
                                  expression: "optimizeParams.no",
                                },
                              }),
                              _c("v-text-field", {
                                attrs: {
                                  label: "nw",
                                  type: "number",
                                  outlined: "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [
                                          _vm._v("n"),
                                          _c("sub", [_vm._v("w")]),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  2557382677
                                ),
                                model: {
                                  value: _vm.optimizeParams.nw,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.optimizeParams, "nw", $$v)
                                  },
                                  expression: "optimizeParams.nw",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-expansion-panel",
                { attrs: { disabled: _vm.isFinished } },
                [
                  _c("v-expansion-panel-header", [
                    _vm._v("Поменять прочие параметры"),
                  ]),
                  _c(
                    "v-expansion-panel-content",
                    [
                      _c(
                        "v-form",
                        [
                          _c("v-switch", {
                            attrs: {
                              label: "Тестовый прогон",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.flags.mock,
                              callback: function ($$v) {
                                _vm.$set(_vm.flags, "mock", $$v)
                              },
                              expression: "flags.mock",
                            },
                          }),
                          _c("v-switch", {
                            attrs: {
                              label: "Оптимизировать общий объем пласта",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.flags.includeVr,
                              callback: function ($$v) {
                                _vm.$set(_vm.flags, "includeVr", $$v)
                              },
                              expression: "flags.includeVr",
                            },
                          }),
                          _c("v-switch", {
                            attrs: {
                              label: "Оптимизировать ОФП",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.flags.includeRelativePerm,
                              callback: function ($$v) {
                                _vm.$set(_vm.flags, "includeRelativePerm", $$v)
                              },
                              expression: "flags.includeRelativePerm",
                            },
                          }),
                          _c("v-switch", {
                            attrs: {
                              label: "Оптимизировать ОФП для каждого перетока",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.flags.connectionRelativePerm,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.flags,
                                  "connectionRelativePerm",
                                  $$v
                                )
                              },
                              expression: "flags.connectionRelativePerm",
                            },
                          }),
                          _c("v-switch", {
                            attrs: {
                              label:
                                "Подгонять все итоговые объемы жидкостей под наблюдаемые значения (а не только нефть)",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.flags.matchConnectionFlow,
                              callback: function ($$v) {
                                _vm.$set(_vm.flags, "matchConnectionFlow", $$v)
                              },
                              expression: "flags.matchConnectionFlow",
                            },
                          }),
                          _c("v-switch", {
                            attrs: {
                              label: "Журналировать оптимизатор",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.flags.logOptimizer,
                              callback: function ($$v) {
                                _vm.$set(_vm.flags, "logOptimizer", $$v)
                              },
                              expression: "flags.logOptimizer",
                            },
                          }),
                          _c("v-switch", {
                            attrs: {
                              label: "Журналировать симулятор",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.flags.logSimulator,
                              callback: function ($$v) {
                                _vm.$set(_vm.flags, "logSimulator", $$v)
                              },
                              expression: "flags.logSimulator",
                            },
                          }),
                          _c("v-switch", {
                            attrs: {
                              label: "Однопоточная оптимизация",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.flags.singleThread,
                              callback: function ($$v) {
                                _vm.$set(_vm.flags, "singleThread", $$v)
                              },
                              expression: "flags.singleThread",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }